import { memo } from 'react'

import type { HeroCarouselItemsBackgroundProps } from '../hero-carousel'
import { isContentCenterAligned } from '../utils'
import { GatsbyImage, IGatsbyImageData, getImage } from 'gatsby-plugin-image'

interface BackgroundProps {
  heroCarouselImages: any
  background: HeroCarouselItemsBackgroundProps
  url: string | undefined
  children: JSX.Element
  alignment: string
  index: number
}

interface GatsbyImageProp {
  publicURL: string
  image: IGatsbyImageData
}

const Background = ({
  heroCarouselImages,
  background,
  url,
  children,
  alignment,
  index,
}: BackgroundProps) => {
  let gatsbyImageData: GatsbyImageProp = {
    publicURL: '',
    image: {
      layout: 'fixed',
      width: 0,
      height: 0,
      images: {
        sources: [],
        fallback: { src: '' },
      },
    },
  }

  const regex = /(___)([^\.]+)\.(png|tiff|jpg|gif)/
  const matchResult = url?.match(regex)

  if (matchResult && matchResult[2]) {
    let result = heroCarouselImages.allFile.nodes.find((el: any) =>
      el.publicURL.includes(matchResult[2])
    )

    gatsbyImageData = {
      publicURL: result?.publicURL,
      image: result?.childImageSharp,
    }
  }

  const getOrderAlignment = () => {
    let result: number | undefined

    switch (alignment) {
      case 'horizontal-align-center':
        result = undefined
        break
      case 'horizontal-align-right':
        result = 1
        break
      case 'horizontal-align-left':
        result = 2
        break
      default:
        result = undefined
        break
    }

    return result
  }
  const getDisplay = () => {
    return !isContentCenterAligned(alignment) ? 'flex' : 'grid'
  }

  const getWidth = () => {
    return !isContentCenterAligned(alignment) ? '50%' : '100%'
  }

  const getGap = () => {
    return !isContentCenterAligned(alignment) ? '0.5rem' : undefined
  }

  const image = getImage(gatsbyImageData?.image)

  if (!background || !background.backgroundImages.length) {
    return <>{children}</>
  }

  return (
    <>
      <div
        className="relative h-[296px] justify-center md:justify-normal items-center md:items-baseline"
        style={{
          backgroundColor: `${background.backgroundColor ?? ''}`,
          display: getDisplay(),
          gap: getGap(),
        }}
      >
        <div
          className="h-full relative overflow-hidden"
          style={{
            width: getWidth(),
            order: getOrderAlignment(),
          }}
        >
          {image && matchResult ? (
            <GatsbyImage
              image={image}
              alt="hero carousel image"
              loading={index === 0 ? 'eager' : 'lazy'}
            />
          ) : (
            <img
              src={gatsbyImageData?.publicURL}
              alt="hero carousel image"
            ></img>
          )}
        </div>
        {children}
      </div>
    </>
  )
}

export default memo(Background)
